import { createContext, type ReactNode } from "react";

export type SecondarySidebarContextValue = {
  content: ReactNode;
  setContent: (content: ReactNode) => void;
};

export const SecondarySidebarContext =
  createContext<SecondarySidebarContextValue | null>(null);
